export const KPI_PERCENTAGES_FOR_TARGETS = {
  salesTargets: {
    onTrack: 90, // if progress is more than 90% of expected progress then on track
    offTrack: 80, // if progress is more than 80% and less than 90% of expected progress then off track
  },
  hectareTargets: {
    onTrack: 90,
    offTrack: 80,
  },
  deliveries: {
    onTrack: 90,
    offTrack: 61, // if progress is more than 61% and less than 90% of expected progress then off track
  },
  seasonTasks: {
    onTrack: 90,
    offTrack: 61,
  },
  collections: {
    onTrack: 90,
    offTrack: 61,
  },
};
